import { createRoot } from "react-dom/client";
import React from "react";
import MediaIndex from "../components/MediaIndex/App";

const PageMediaIndex = ($) => {
	if ($("body").hasClass("page-template-watch-listen-index")) {
		const newsIndexRootElement = document.getElementById("js--media-index");
		const newsIndexRoot = createRoot(newsIndexRootElement);
		newsIndexRoot.render(<MediaIndex />);
	}
};

export default PageMediaIndex;
